import { render, staticRenderFns } from "./ShenPiNewYanfaBxEdit.vue?vue&type=template&id=3afe0165&scoped=true&"
import script from "./ShenPiNewYanfaBxEdit.vue?vue&type=script&lang=js&"
export * from "./ShenPiNewYanfaBxEdit.vue?vue&type=script&lang=js&"
import style0 from "./ShenPiNewYanfaBxEdit.vue?vue&type=style&index=0&id=3afe0165&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afe0165",
  null
  
)

export default component.exports